<template>

    <div class="favorite" v-if="isAuth">
        <a 
            class="button button--add-to-favorite single_add_to_cart_button"
            :class="{'is-active': isFavorite, 'disabled': !isActive}"
            :disabled="!isActive"
            title="Ajouter au favoris"
            v-on:click="toggleFavorite()">
            <i class="fa fa-heart"></i>
            <span class="button__label">Ajouter au favoris</span>
        </a>
    </div>

</template>

<script>
import { mapState } from 'vuex'

import { useLogin } from '@/helpers/auth'
import { actions } from '@/store/articles'

export default {

    name: 'Favorite',

    data() {
        return {
            ready: false,
            uvCode: null
        }
    },

    computed: {
            
        isActive: function () {
            return (
                    this.ready &&
                    ( !this.isVariable || ( this.isVariable && this.uvCode !== null ) )
                )
        },

        isAuth: () => {
            const { isLogged } = useLogin()
            return isLogged
        },

        isVariable: function () {
            return ( this.article.articleVariations && this.article.articleVariations.length > 1 )
        },

        ...mapState({

            article: state => state.articles.current,

            isFavorite: function (state) {

                let favorites = state.articles.allFavorites
                if ( !favorites || !this.article ) {
                    return false
                }

                let isFavorite = false
                favorites.forEach(favorite => {
                    this.article.articleVariations.forEach(articleVariation => {
                        if ( articleVariation.postId === favorite.postId
                            && articleVariation.uvCode === this.uvCode ) {
                            isFavorite = true
                        }
                    })
                });

                return isFavorite
            }
        })
    },

    methods: {

        toggleFavorite: function() {

            if ( !this.ready ) {
                return
            }

            this.article.articleVariations.forEach(articleVariation => {

                if ( articleVariation.uvCode === this.uvCode ) {
                    
                    if ( this.isFavorite ) {                
                        this.$store.dispatch(actions.REMOVE_FAVORITE, articleVariation)   
                            .then(() => this.$notify.success( 'Article ' + this.article.title + ' retiré des favoris' ))  
                    }
                    else {
                        this.$store.dispatch(actions.ADD_FAVORITE, articleVariation)   
                            .then(() => this.$notify.success( 'Article ' + this.article.title + ' ajouté aux favoris' ))            
                    }
                }
            })
        },

        updateUvCode: function() {

            if ( !this.article ) {
                this.uvCode = null
                return
            }
            
            if ( this.isVariable ) {
                document.getElementsByName('attribute_conditionnement').forEach(conditionnementSelect => {
                    this.uvCode = ( conditionnementSelect.value && conditionnementSelect.value.length > 0 ) ? conditionnementSelect.value : null
                })
                return
            }

            this.uvCode = this.article.articleVariations[0].uvCode ?? null
            
        }
    },

    created() {

        if ( !this.isAuth ) {
            return
        }

        Promise.all([
            this.$store.dispatch(actions.GET),
            this.$store.dispatch(actions.GET_ALL_FAVORITES)
        ])
        .then( () => {
            this.updateUvCode()
            this.ready = true
        })
    },

    mounted() {

        document.getElementsByName('attribute_conditionnement').forEach(conditionnementSelect => {
            conditionnementSelect.addEventListener('change', () => this.updateUvCode() )
        })
    }
}
</script>

<style>

/* Woocommerce override */

.woocommerce .favorite {
    float: left;
}

.woocommerce .button.button--add-to-favorite {
    margin-left: 1rem;
    min-width: auto;
}

.woocommerce .button.button--add-to-favorite.is-active {
    background-color: rgb(5, 176, 144) !important;
    border-color: rgb(5, 176, 144) !important;
}

.woocommerce .button.button--add-to-favorite .button__label {
    display: none;
}

/* Favorite */

</style>
